module.exports = __webpack_public_path__ + "static/media/doctor1.b272e6e0.svg";